import { onFilterChange } from '../components/blocks/ProductListPage/ProductListPage';
import Api from './api';

let browserGames;
// Active games change only with an admin edit, so the browser asks once per tab:
// a singles filter click then waits for one request (the listing), not two in a row.
export function activeCardGames(ctx) {
  if (typeof window === 'undefined') return Api.get('/public/card-games', null, null, ctx);
  browserGames = browserGames || Api.get('/public/card-games').catch(error => { browserGames = null; throw error; });
  return browserGames;
}

export async function singlesListingProps(ctx, game) {
  const query = ctx.query || {};
  const page = Math.max(1, parseInt(query.page, 10) || 1);
  const search = typeof query.search === 'string' ? query.search.trim() : '';
  const sort = query.sort || (search ? 'relevance' : 'popular');
  const raw = Array.isArray(query.filters) ? query.filters : query.filters ? [query.filters] : [];
  const filters = raw.flatMap(filter => {
    const split = filter.indexOf('_');
    return split > 0 ? [{ id: filter.slice(0, split), value: filter.slice(split + 1).split(';') }] : [];
  });
  const response = await onFilterChange({ page, pageSize: 24, sort, filters, search, view: 'singles', game }, ctx);
  return { ...response, page, sort, sortDirection: query.sortDirection || 'DESC' };
}
